/* eslint-disable */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {KTSVG} from '../../../helpers'
import {Modal} from 'react-bootstrap'

const ContentModal = ({onOpen, onClose, error, title, children}) => {
  const [show, setShow] = useState(onOpen)

  useEffect(() => {
    setShow(onOpen)
  }, [onOpen])

  const handleClose = () => {
    setShow(false)
    onClose && onClose()
  }

  useEffect(() => {
    if (error && show) {
      setShow(false)
    }
  }, [error])

  return (
    <>
      <Modal
        className='modal-sticky modal-sticky-xl modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={show}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        size='xl'
        onHide={handleClose}
      >
        <div className='modal-content'>
          <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
            <h5 className='fw-bold m-0'>{title}</h5>
            <div className='d-flex ms-2'>
              <div
                className='btn btn-icon btn-sm btn-light-primary ms-2'
                data-bs-dismiss='modal'
                onClick={handleClose}
              >
                <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
          </div>

          <div className='d-block py-5 ps-8 pe-5 '>{children}</div>
        </div>
      </Modal>
    </>
  )
}

ContentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
}

ContentModal.defaultProps = {
  onOpen: false,
}

export {ContentModal}
